import type { FaireProductEntity } from "../../entity_types/product";

export const p_rxpre96fd7: FaireProductEntity = {
  token: "p_rxpre96fd7",
  type: "product",
  name: "HALTER NECK PLAID MINI DRESS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/a67798cc80d2b55f46feef4d0be38621d36514935d8e05f200f667c3f895767b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60169c7bd8a726912e1ed5012abc379e57b5e38cfc54ca80c88665c1c2ba70ef.jpeg",
    "https://cdn.faire.com/fastly/c54f3f61adccd2594f8fe9ab93264d13ecc5bec118e844ffd928aa013bfdb452.jpeg",
    "https://cdn.faire.com/fastly/a1671b0595e89000890dba7eadfc1d945bb76392824be6b8638ca85981c8ccb1.jpeg",
    "https://cdn.faire.com/fastly/a8289434cfc4ba96e2d3ce4d8c0e4e7ac3fff9784570de79b6085cc25c414228.jpeg",
    "https://cdn.faire.com/fastly/afef3413a26b489316b475169f314e76300f030991e025eafc3a9d48e2e86c6c.jpeg",
  ],
  priceDollars: 174,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:15.731Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
